import Footer from "../footer/Footer";
import BlogNavbar from "../navbar/BlogNavbar";

const BlogsLayout = ({ navbarType, children }) => {
  return (
    <div>
      <BlogNavbar navbarType={navbarType} />
      <div>
        <main>{children}</main>
      </div>
      <footer>
        <Footer />
      </footer>
    </div>
  );
};

export default BlogsLayout;
